<script>
  import { isStart, playerColor } from '../store/store';

  let name = 'world';
  let gamePresent = false;
  gamePresent = true;
  import Start from './Start.svelte';
  import Game from './Game.svelte';
</script>

{#if $isStart}
  <nav class="main-nav">
    <Start />
  </nav>
{:else}
  <main class="main-content">  
    <Game --player-color={$playerColor} />
  </main>
{/if}

<style>
  .main-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: inherit;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: inherit;
  }

  @media only screen and (min-width: 1000px) {
    .main-nav {
      flex-direction: column;
      height: inherit;
    }

    .main-content {
      flex-direction: row;
      height: inherit;
    }

  }

</style>